// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--e30e3";
export var accordion_item = "Accordion-module--accordion_item--51505";
export var accordion_item_body = "Accordion-module--accordion_item_body--a31fe";
export var accordion_item_header = "Accordion-module--accordion_item_header--10a44";
export var accordion_item_header_icon = "Accordion-module--accordion_item_header_icon--cd4e3";
export var selected = "Accordion-module--selected--103bd";